const OVERLAP_PX = 26;

export const updateGameViewportHeight = (): void => {
  document.documentElement.style.setProperty(
    '--vh',
    `${window.innerHeight * 0.01}px`,
  );

  const iframe = document.getElementById(
    'swipeSDKFrame',
  ) as HTMLIFrameElement | null;
  if (!iframe) return;

  const menu = document.getElementById('sdk-drawer-menu');
  const panel = menu?.querySelector(
    '.sdk-drawer-menu__panel',
  ) as HTMLElement | null;
  const isOpen = menu?.classList.contains('open');
  const menuHeight = isOpen && panel ? panel.getBoundingClientRect().height : 0;

  if (!menuHeight) {
    iframe.style.transform = '';
    iframe.style.transformOrigin = '';
    iframe.style.top = '0px';
    return;
  }

  const availableHeight = window.innerHeight - menuHeight + OVERLAP_PX;
  const scale = availableHeight / window.innerHeight;

  iframe.style.transformOrigin = 'top center';
  iframe.style.transform = `scale(${scale})`;
  iframe.style.top = `${menuHeight - OVERLAP_PX}px`;
};

export default updateGameViewportHeight;
